export const getValuePerSecond = state => state.counter.valuePerSecond;

export const getIslandProgress = state => state.counter.islandProgress;

export const getCount = state => state.counter.count;

export const getLootSpeed = state => state.counter.lootSpeed;

export const getLoot = state => state.counter.loot;

export const getGameData = state => state.counter;

export const getIslandSearchingStatus = state => state.counter.searchingIsland;
